import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import $ from 'jquery';
import simpleDialog from 'simple-dialog';

Component('tr-project-timeline-dependency', {
  mixins: [eventListenerMixin],

  properties: {
    parentId: String,
    childId: String,
    url: String,
  },

  connected() {
    this.svg = this.querySelector('svg');
    this.timeline = document.querySelector('tr-project-timeline');
  },

  ready() {
    this.render();
  },

  render() {
    this.parent = this.timeline.querySelector(
      `tr-project-timeline-todo[todo-id="${this.parentId}"]`,
    );
    this.child = this.timeline.querySelector(`tr-project-timeline-todo[todo-id="${this.childId}"]`);

    if (!this.parent || !this.child) {
      this.remove();
      return;
    }

    if (this.parent.classList.contains('hide') || this.child.classList.contains('hide')) {
      this.classList.add('hide');
      return;
    }

    this.classList.remove('hide');
    this.renderPath();
    this.setPosition();

    const hoverPath = this.querySelector('.dependency-path-hover');
    this.listenTo(hoverPath, {
      mouseenter: () => {
        this.classList.add('active');
      },
      mouseleave: () => {
        this.classList.remove('active');
      },
      click: () => {
        const dialog = simpleDialog.confirm({
          content: this.dataset.confirmText,
          callback: (e, yes) => {
            dialog.remove();
            if (!yes) return;
            this.remove();
            $.ajax({
              url: this.url,
              type: 'delete',
              dataType: 'script',
            });
          },
        });
      },
    });
  },

  renderPath() {
    this.svg.innerHTML = '';

    const pw = this.parent.querySelector('.timeline-todo-wrapper');
    const cw = this.child.querySelector('.timeline-todo-wrapper');
    const endLeft = cw.offsetLeft - pw.offsetLeft - pw.offsetWidth;
    const endTop = this.child.offsetTop - this.parent.offsetTop;

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.classList.add('dependency-path');
    path.setAttribute('d', `M0,0 C80,0 ${endLeft - 80},${endTop} ${endLeft},${endTop}`);
    this.svg.appendChild(path);

    const pathHover = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    pathHover.classList.add('dependency-path-hover');
    pathHover.setAttribute('d', `M0,0 C80,0 ${endLeft - 80},${endTop} ${endLeft},${endTop}`);
    this.svg.appendChild(pathHover);

    const arrow = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    arrow.classList.add('dependency-arrow');
    arrow.setAttribute(
      'd',
      `M${endLeft},${endTop} ${endLeft - 8},${endTop - 4} ${endLeft - 8},${endTop + 4}`,
    );
    this.svg.appendChild(arrow);
  },

  setPosition() {
    const wrapper = this.parent.querySelector('.timeline-todo-wrapper');
    const top = this.parent.offsetTop + 3;
    const left = wrapper.offsetLeft + wrapper.offsetWidth;
    this.style.top = `${top}px`;
    this.style.left = `${left}px`;
  },

  disconnected() {
    this.stopListening();
  },
});
